import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enTranslations from './locales/en.json';
import esMXTranslations from './locales/es-MX.json';

// Function to determine default language based on domain
const getDefaultLanguage = () => {
  const hostname = window.location.hostname;
  return hostname === 'todoactivo.com' ? 'es-MX' : 'en';
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: enTranslations,
      },
      'es-MX': {
        translation: esMXTranslations,
      },
    },
    fallbackLng: 'en',
    lng: getDefaultLanguage(), // Set initial language based on domain
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
  });

export default i18n; 